// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScissorOutlinedSvg from "@fishx/icons-svg/es/asn/ScissorOutlined";
import FishxIcon from '../components/FishxIcon';

var ScissorOutlined = function ScissorOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScissorOutlinedSvg
  }));
};

ScissorOutlined.displayName = 'ScissorOutlined';
export default React.forwardRef(ScissorOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ScissorOutlined.js
// module id = 4074
// module chunks = 0